import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import ComponentsInput from "./ComponentsInput";

export default function ToolboxFormDialog({ open, onClose, initial, onSave, saving }) {
  const [name, setName] = useState(initial?.toolbox_name || "");
  const [description, setDescription] = useState(initial?.toolbox_description || "");
  const [components, setComponents] = useState(initial?.components || []);

  useEffect(() => {
    setName(initial?.toolbox_name || "");
    setDescription(initial?.toolbox_description || "");
    setComponents(initial?.components || []);
  }, [initial, open]);

  const handleSubmit = () => {
    onSave({
      _id: initial?._id,
      name,
      description,
      components,
    });
  };

  const isValid = name.trim().length > 0 && components.length > 0;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{initial?._id ? "Edit Toolbox" : "New Toolbox"}</DialogTitle>
      <DialogContent>
        <Box display="grid" gridGap={16}>
          <TextField
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            fullWidth
            required
          />
          <TextField
            label="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            fullWidth
            multiline
            rows={3}
          />
          <ComponentsInput
            value={components}
            onChange={setComponents}
            helperText="Components are stored in uppercase."
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          color="quCreate"
          variant="contained"
          disabled={!isValid || saving}
        >
          {saving ? <CircularProgress size={20} /> : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
